<template>
    <div class="app-container">

        <el-card class="search-form-card">

            <!-- <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="拓扑名称">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" style='width: 200px;'></el-input>
                    <el-button type="primary" @click='loadData'>搜索</el-button>
                </el-form-item>
            </el-form> -->
        </el-card>
        <el-card>

            <div slot="header">
                <router-link  :to="{ path:'/addRelationShip', query: { serialNumber: form.topology_id, callback: request } }">
                    <el-button type="primary">新增关系</el-button>
                </router-link>
                <!-- <router-link  :to="{ path:'/topologicalGraph', query: { serialNumber:form.topology_id }}">
                    <el-button type="primary">查看拓扑图</el-button>
                </router-link> -->
                <router-link  :to="{ path:'/topologicalGraph', query: { serialNumber:form.topology_id,type:'topologyMap' }}">
                    <el-button type='primary'>查看拓扑图</el-button>
                </router-link>
            </div>

            <el-table :data="tableData" style="width: 100%" stripe v-loading='loading'>

                <el-table-column label="From" align="center">
                    <el-table-column prop="from_title" label="名称"></el-table-column>
                    <el-table-column prop="from_category" label="分类"></el-table-column>
                    <el-table-column prop="from_status" label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.from_status | tableVal(cmdbStatus) }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="To" align="center">
                    <el-table-column prop="to_title" label="名称"></el-table-column>
                    <el-table-column prop="to_category" label="分类"></el-table-column>
                    <el-table-column prop="to_status" label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.to_status | tableVal(cmdbStatus) }}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="关系类型" prop="company">
                    <template slot-scope='scope'>
                        {{ scope.row.relationship | tableVal(cmdbRelationshipType) }}
                    </template>
                </el-table-column>

                <el-table-column label="描述" prop="description"></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">

                        <!-- <router-link  :to="{ path:'/configurationUpdata', query: { callback:request, type: 'edit', serialNumber:scope.row.serialNumber } }">
                            <el-button type='text'>编辑</el-button>
                        </router-link> -->
                        <el-button v-w-role="'ITSM-0101'"  class="table-del-btn" @click.native.prevent="deleteRow(scope.$index, tableData, scope.row.id)" type="text">删除</el-button>

                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.page_index"
             :page-sizes="[10,20, 30, 40]"
             :page-size="form.page_size"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>
        </el-card>
        <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
          <el-form :model="form" >
            <el-form-item label="活动名称" label-width="100">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="活动区域" label-width="120">
                <el-input type="textarea" autosize
                    placeholder="请输入内容" v-model="form.textarea1">
                </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import services from '../configuration.services'
export default {

    data() {
        return {
            form: {
                page_index: 1,
                page_size: 10,
                topology_id: ''
            },
            total: 0,
            pageSizes: [10, 20, 30, 40],
            tableData: [],
            loading: true,
            dialogFormVisible:false,
            detail:{}
        }
    },

    computed:{
        dictionary(){
            return this.$store.state.dictionary;
        },
        // 状态
        cmdbStatus(){
            return this.dictionary.cmdb_status;
        },
        // 关系类型
        cmdbRelationshipType() {
            return this.dictionary.cmdb_relationship_type
        },
        topology_id(){
            return this.$route.query.topology_id;
        },
    },

    mounted() {
        // console.log(this.topology_id)
        this.form.topology_id = this.topology_id
        this.request()
    },

    methods: {
        //新增拓扑
        addTopologyEvent(){
            this.dialogFormVisible = true
        },
        loadData(){
            this.form.page_index=1
            this.request()
        },
        // 请求数据
        request() {
            this.tableData = []
            this.loading = true
            services.topologyRelationList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 删除列表某一项
        deleteRow(index, rows, relationId) {
            this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    services.topologyRelationDel({id: relationId})
                        .then(res => {
                            this.$message.success('删除成功!')
                            rows.splice(index, 1);
                        }).catch(err => this.$message.error(err.message))
                }).catch(() => {
                    this.$message.info('已取消删除');
            });
        },

        // 更新分页器页数
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.page_size = val;
            if(this.form.page_index > pages ){
                this.form.page_index  = 1;
            };
            this.request();
        },

        // 更新分页器页码
        handleCurrentChange(val){
            this.form.page_index = val;
            this.request();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>

